import { render, staticRenderFns } from "./radish-dup.vue?vue&type=template&id=2f86a56a"
import script from "./radish-dup.vue?vue&type=script&lang=js"
export * from "./radish-dup.vue?vue&type=script&lang=js"
import style0 from "./radish-dup.vue?vue&type=style&index=0&id=2f86a56a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports